import type { CannedCollectionModuleCard, ColorChoice } from '@coursera-web/cds-labs';

import type { PromoTemplateCannedCollectionFragment } from 'bundles/front-page/__generated__/contentfulTypes';

const normalizePromoUnitsModuleContent = (content: PromoTemplateCannedCollectionFragment) => {
  const filteredItems = content.cardsCollection?.items?.filter(Boolean);

  if (!filteredItems || !filteredItems.length) return [];

  const normalizedItems = filteredItems
    .map((item) => {
      if (!item.headline || !item.target) return null;
      return {
        id: item.sys.id,
        eyebrowImage: item.eyebrowImage,
        eyebrowImageHeight: item.eyebrowImageHeight,
        headline: item.headline,
        body: item.body,
        cardBackgroundImage: item.cardBackgroundImage,
        mobileCardBackgroundImage: item.mobileCardBackgroundImage,
        ctaText: item.ctaText,
        target: item.target,
        backgroundColor: item.backgroundColor as ColorChoice,
        ctaVariant: 'ghostInvert',
        openInNewTab: false,
      } as Omit<CannedCollectionModuleCard, 'onClick'>;
    })
    .filter(Boolean);

  return normalizedItems;
};

export default normalizePromoUnitsModuleContent;
